export const ACCESS_TOKEN_STORAGE_KEY = '@HomeSharing::accessToken';
